import PatientsSearchComponent from "../../VeinsTracker/PatientsSearchComponent.vue";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
// import PatientComponent from "../Patients/PatientComponent.vue"; // $$**$$
import DropDownModal from "../../Patients/DropDownModal.vue";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import PatientComponent from "../../../components/PatientComponent.vue";

export default {
  name: "Checkout",

  // $$**$$
  components: {
    PatientComponent,
    DropDownModal,
    PatientsSearchComponent
  },

  data() {
    return {
      currentDateRange:"",
      showProfilePopupVar:true,
       ActivePaymentRequest: {},
      //reminder
      Reminder: [],
      paymentReminder: {
        visitId: 0,
        email: "",
        phone: "",
        actionDate: new Date(),
      },
      //merge variables
      //-- Search
      suggested: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        Dob: "",
        searchDate: null,
      },
      suggested1: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        Dob: "",
        searchDate: null,
      },
      suggestedPatients1: [],
           //Data table MergeSugg
      pageNumberSuggest: 1,
      pageSizeSuggest: 50,
      totalPagesSuggest: 0,
      totalRowsSuggest: 0,

      //Data table MergeSugg
      pageNumberSuggest1: 1,
      pageSizeSuggest1: 50,
      totalPagesSuggest1: 0,
      totalRowsSuggest1: 0,
       //merge variables
      //receipt
       SendReceiptRequest:{
        PatientId:0,
        VisitId:0,
        LocalDateTime:new Date,
        BillNo:0,
        PNDX:0,
        Email:"",
        Phone:"",
        DC:"",
      },

      btnProColl: false,
      displayPayMethod: false,
      pageNumberPays: 1,
      pageSizePays: 50,
      totalPagesPays: 0,
      totalRowsPays: 0,
      button_Name: String,
     // ***Sort Main Table
      mainSort: {
        name: 0,
        dos: 0,
        visitType: 0,
        timein: 0,
      },

      stdDate: "",
      initDate_2: "",

      //Page
      showPagesMin1: 1,
      showPagesMax1: 5,
      showPagesMin:1,
      showPagesMax:5,
      VhpageNumber: 1,
      VhpageSize: 50,
      VhtotalRows:0,
      VhtotalPages:0,
       //paymentHistory
      PhpageNumber: 1,
      PhpageSize: 50,
      PhtotalRows:0,
      PhtotalPages:0,
      //paymentHistory
      //Data table
      pageNumber: 1,
      pageSize: 50,
      totalPages: 0,
      Search: "",
      totalRows: 0,
      DataTable: {},
      sortColumn: 0,
      sortColumnOption: 0,
      sortColumnPay: 0,
      sortColumnOptionP: 0,

      p_visitId: Number,
      showDropDownModal: false,

      val11: "",
      val22: "",

      //merge
      phone: "",
      email: "",
      ssn: "",
      address: "",
      city: "",
      state: "",
      zip:"",
      primaryInsurance: "",
      primaryInsuranceNo: "",
      primaryInsuranceId: "",
      primaryInsuranceGroupId: "",
      secondInsurance: "",
      secondInsuranceNo: "",
      secondInsuranceId: "",
      secondInsuranceGroupId: "",

      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,
      loader: "",
      PvisitId: "",
      //Timer
      TimerObject: {},
      interval: {},
      timeCheck: "",

      visitReasons: [],
      stagesSteps: [],
      commentText: "",
      commentsList: [],
      phyList: [],
      aSelectedPatient: "",
      aSelectedInsurance: "",
      allPatients: [],
      allInsurances: [],

      //Merge filters
      filterFirstName: "",
      filterLastName: "",
      filterPhone: "",
      filterDate: "",
      filterDDate: "",

      // Date
      checkoutPatients: [],
      allFilterPatientsCheck: [],
      startDate: "",
      endDate: "",
      startDate_1: "",
      endDate_1: "",
      startDate_2: "",
      endDate_2: "",
      startDate11: "",
      endDate11: "",
      initDate_11: "",

      // Single Patient
      aSinglePatient: {
       stats: {
          visits: 0,
          payments: 0,
          texts: 0,
          emails: 0
        },
        email: "",
        phone: "",
        externalId: 0,
        insurance: {
          primaryInsurance: "",
          primaryInsuranceId: "",
          primaryInsuranceNo: "",
          primaryInsuranceGroupId: "",
          secondaryInsurance: "",
          secondaryInsuranceId: "",
          secondaryInsuranceNo: "",
          secondaryInsuranceGroupId: "",
        },
      },
      insurance: {
        pndx: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
        primaryFilePath: "",
        secondaryFilePath: "",
      },

      suggestedPatients: [],
      emailHistory: [],
      aSingleUserSmsHist: [],
      paymentHistory: [],
      requestPaymentsList: [],
      smsTempsList: [],
      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      },
      //payment status Text update list
      paymentStatus: [
        { text: "Sent", PValue: 1 },
        { text: "Pending", PValue: 2 },
        { text: "Disputed", PValue: 3 },
        { text: "Paid", PValue: 4 },
      ],
      //SMS Send
      aSingleSms: {
        name: "",
        smsText: "",
      },
      chatSms: "",
      //Email Object Used to send Emails
      emailTempsList: [],
      aSingleEmail: {
        name: "",
        emailText: "",
        emailSubject: "",
      },
      // a Single request payment
      aSingleRequestPayment: {
        patientId: 0,
        amount: 0,
        email: "",
        phone: "",
        comment: "",
      },
      visitQuests: [],
      visitDemo: [],
      textHistory: [],
      visitHistory: [],
      users: [],

      //-- Search
      allFilterPatients_1: [],
      allFilterVisitHist: [],
      mainSearch: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
      },

      propPatientSource: { visitId: 0, patientId: 0, updButton: 1 , ptid: ""}, //-- $$**$$

     // for merge 
      VisitPayCounts: [],
      aSelectedCounts:[],

      mergedPat: {
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
        phone: "",
        email: "",
        ssn: "",
        address: "",
        city: "",
        state: "",
        zip: "",

        primaryIns: "",
        primaryInsNo: "",
        primaryInsGroupId: "",
        primaryInsId: "",

        secondIns: "",
        secondInsNo: "",
        secondInsGroupId: "",
        secondInsId: ""
      },
    };
  },
  methods: {
    deletePayment(pay) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to Delete this Payment. This action \n cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          const obj = {
            DC: this.dummyComm,
            PR: pay,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/DeletePayment";
          this.axiosGetData(url, obj, 9001);
        }
      });
    },
    //Reminder
     sendReminderClick() {
      if (this.Reminder.email == "") {
        this.showErrorToast("Email is require");
        return;
      }
      if (this.Reminder.phone == "") {
        this.showErrorToast("Phone is require");
        return;
      }

      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

      const Reminder1 = {
        PNDX: this.Reminder.pndx,
        BillNo: this.Reminder.billNo,
        VisitId: this.Reminder.visitId,
        PatientId: this.Reminder.patientId,
        Amount: this.Reminder.amount,
        Email: this.Reminder.email,
        Phone: this.Reminder.phone,
      };

      const myData = { dc: this.dummyComm, pr: Reminder1 };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SendPaymntReminder";
      this.axiosGetData(url, myData, 9000);
    },
    paymentCollectMethodModal(pay){
      this.displayPayMethod = true;
      this.ActivePaymentRequest = pay;
      this.limitAmount = pay.amount;
      this.aSinglePaymentReceived.amount = this.ActivePaymentRequest.amount;
    },
    //receipt
    sendReceipt(pay){
      $('#displayReceipt').modal("show");
      this.SendReceiptRequest.PatientId = pay.patientId;
      this.SendReceiptRequest.PracticeId = pay.pacticeId;
      this.SendReceiptRequest.Email = pay.email;
      this.SendReceiptRequest.Phone = pay.phone;
      this.SendReceiptRequest.BillNo = pay.billNo;  
      this.SendReceiptRequest.VisitId = pay.visitId;
      this.SendReceiptRequest.LocalDateTime = new Date;   
      this.SendReceiptRequest.PNDX = pay.pndx;
    },
    sendReceiptClick(){
      this.intDummyComm();
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      const url =
      this.SERVER + "/VNSPRAAPI/Payments/SendReceiptReminder";   
      const myData = this.SendReceiptRequest;
      myData.DC = this.dummyComm;
      this.axiosGetData(url, myData, 9002);
    },
      showSubmitPaymentModal(methodType) {
      this.displayPayMethod = false;
      if(methodType==1)
      { $("#debit").modal("show"); }
      else if(methodType==2)
      { $("#cash").modal("show"); }
      else if(methodType==3)
      { $("#cheque").modal("show");} 
    },
       //Reconcile
     showReconcileModel(pay) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to Reconcile this Payment. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          this.dummyComm.extras2 = pay.billNo;
          this.dummyComm.filter = "";

          const myData = {
            dc: this.dummyComm,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/ReconcilePaymentById";
          this.axiosGetData(url, myData, 900);
        }
      });
    },

     //payment Request
     getPaymentResTabl() {
      window.scrollTo(0, 0);
      this.intDummyComm();
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      const url =
      this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsListyId";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 8000);
     },

    datePicker_2() {//this is comment
    
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function(start, end) {
          self.startDate_2 = new Date(start);
          self.endDate_2 = new Date(end);
          self.initDate_2 =
            self.dateToMDY(self.startDate_2) +
            " - " +
            self.dateToMDY(self.endDate_2);
        }
      );
    },   
    PhOrderBy(column){
      // if(this.firstTime==true)
      // {
      //   this.firstTime = false;
      //   return;
      // }
      this.orderByCol = column;
      if(column==1)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.dosStr < b.dosStr) ? 1 : ((b.dosStr < a.dosStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.dosStr > b.dosStr) ? 1 : ((b.dosStr > a.dosStr) ? -1 : 0))
        }
        
      }
      if(column==2)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.amount < b.amount) ? 1 : ((b.amount < a.amount) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.amount > b.amount) ? 1 : ((b.amount > a.amount) ? -1 : 0))
        }
      }
      if(column==3)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.paymentMethodStr < b.paymentMethodStr) ? 1 : ((b.paymentMethodStr < a.paymentMethodStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.paymentMethodStr > b.paymentMethodStr) ? 1 : ((b.paymentMethodStr > a.paymentMethodStr) ? -1 : 0))
        }
      }
      if(column==4)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.comment < b.comment) ? 1 : ((b.comment < a.comment) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.comment > b.comment) ? 1 : ((b.comment > a.comment) ? -1 : 0))
        }
      }
      if(column==5)
      {
      if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.statusStr < b.statusStr) ? 1 : ((b.statusStr < a.statusStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.statusStr > b.statusStr) ? 1 : ((b.statusStr > a.statusStr) ? -1 : 0))
        }
      }
      if(column==6)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.paymentDateStr < b.paymentDateStr) ? 1 : ((b.paymentDateStr < a.paymentDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.paymentDateStr > b.paymentDateStr) ? 1 : ((b.paymentDateStr > a.paymentDateStr) ? -1 : 0))
        }
      }
      if(column==7)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.collectedByName < b.collectedByName) ? 1 : ((b.collectedByName < a.collectedByName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.collectedByName > b.collectedByName) ? 1 : ((b.collectedByName > a.collectedByName) ? -1 : 0))
        }
      }
      this.ResetLogoutTime();
    },
    VhOrderBy(column){
      if(this.firstTime==true)
      {
        this.firstTime = false;
        return;
      }
      this.orderByCol = column;
      if(column==1)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.visitTypeName < b.visitTypeName) ? 1 : ((b.visitTypeName < a.visitTypeName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.visitTypeName > b.visitTypeName) ? 1 : ((b.visitTypeName > a.visitTypeName) ? -1 : 0))
        }
        
      }
      if(column==2)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.reason < b.reason) ? 1 : ((b.reason < a.reason) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.reason > b.reason) ? 1 : ((b.reason > a.reason) ? -1 : 0))
        }
      }
      if(column==3)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.dosLocalDateStr < b.dosLocalDateStr) ? 1 : ((b.dosLocalDateStr < a.dosLocalDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.dosLocalDateStr > b.dosLocalDateStr) ? 1 : ((b.dosLocalDateStr > a.dosLocalDateStr) ? -1 : 0))
        }
      }
      if(column==4)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.dosLocalTimeStr < b.dosLocalTimeStr) ? 1 : ((b.dosLocalTimeStr < a.dosLocalTimeStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.practices.sort((a,b) => (a.dosLocalTimeStr > b.dosLocalTimeStr) ? 1 : ((b.dosLocalTimeStr > a.dosLocalTimeStr) ? -1 : 0))
        }
      }
      if(column==5)
      {
      if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.stageName < b.stageName) ? 1 : ((b.stageName < a.stageName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.stageName > b.stageName) ? 1 : ((b.stageName > a.stageName) ? -1 : 0))
        }
      }
      if(column==6)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.stepName < b.stepName) ? 1 : ((b.stepName < a.stepName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.stepName > b.stepName) ? 1 : ((b.stepName > a.stepName) ? -1 : 0))
        }
      }
      if(column==7)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.physicianName < b.physicianName) ? 1 : ((b.physicianName < a.physicianName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.physicianName > b.physicianName) ? 1 : ((b.physicianName > a.physicianName) ? -1 : 0))
        }
      }
      if(column==8)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.commentText < b.commentText) ? 1 : ((b.commentText < a.commentText) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.commentText > b.commentText) ? 1 : ((b.commentText > a.commentText) ? -1 : 0))
        }
      }
      this.ResetLogoutTime();
    
    },
        PhpageChange(obj) {
      if (obj == "Next") {
        if (this.PhpageNumber < this.PhtotalPages) {
          this.PhpageNumber += 1;
        }
      } else if (obj == "Previous" && this.PhpageNumber != 1) {
        this.PhpageNumber -= 1;
      } else {
        this.PhpageNumber = obj;
      }

        if((this.showPagesMax1/2) < (this.PhpageNumber))
        {
          this.showPagesMin1 = this.PhpageNumber-4;
          this.showPagesMax1 = this.PhpageNumber+4;
        }
        else if((this.showPagesMin1/2)<(this.PhpageNumber))
        {
          this.showPagesMin1 = this.PhpageNumber-4;
          this.showPagesMax1 = this.PhpageNumber+4 ;
          if(this.showPagesMax1<5)
          {
            this.showPagesMax1 = 5;
          }
        }
        else{
          this.showPagesMin1 = 1;
          this.showPagesMax1 = 5 ;
        }

      this.fetchPayHistory();
    },
    fetchPayHistory() {
      this.intDummyComm();
      if (!this.aSinglePatient) {
        return;
      }
      this.dummyComm.pageNumber = 1;
      this.dummyComm.pageSize = this.pageSize;
      //this.dummyComm.extras = this.initDate_2;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetPaymentHistoryTable";
      this.getaxiosPayHistory(url, this.dummyComm);
    },
     showReminderModel(pay) {
      $("#reminder").modal("show");
      this.Reminder = pay;
    },
    async getaxiosPayHistory(url, myData) {
      await axios({
        method: "post",
        url: url,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          const response = res.data;
          if (response.dc.auditFlag == 1) {
            this.paymentHistory = res.data.paymentHistory;
            this.PhpageNumber = response.pageNumberP;
            this.PhtotalPages =response.totalPagesP;
            this.PhtotalRows = response.totalRowsP;
          } else {
            this.showErrorToast("unable to fetch data");
            console.log("unable to fetch data");
          }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },
      VhpageChange(obj) {
      if (obj == "Next") {
        if (this.VhpageNumber < this.VhtotalPages) {
          this.VhpageNumber += 1;
        }
      } else if (obj == "Previous" && this.VhpageNumber != 1) {
        this.VhpageNumber -= 1;
      } else {
        this.VhpageNumber = obj;
      }

        if((this.showPagesMax1/2) < (this.VhpageNumber))
        {
          this.showPagesMin1 = this.VhpageNumber-4;
          this.showPagesMax1 = this.VhpageNumber+4;
        }
        else if((this.showPagesMin1/2)<(this.VhpageNumber))
        {
          this.showPagesMin1 = this.VhpageNumber-4;
          this.showPagesMax1 = this.VhpageNumber+4 ;
          if(this.showPagesMax1<5)
          {
            this.showPagesMax1 = 5;
          }
        }
        else{
          this.showPagesMin1 = 1;
          this.showPagesMax1 = 5 ;
        }

      this.fetchVisitistory();
    },
    fetchVisitistory() {
      this.intDummyComm();
     //debugger
      if (!this.aSinglePatient) {
        return;
      }
      this.dummyComm.pageNumber = 1;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.extras = this.initDate_2;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetVisitHistory";
      this.getaxiosHistory(url, this.dummyComm);
    },
    async getaxiosHistory(url, myData) {
     //debugger
      await axios({
        method: "post",
        url: url,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
         //debugger
          console.log(res);
          const response = res.data;
          if (response.dc.auditFlag == 1) {
            this.visitHistory = res.data.patientVisitHistories;
            this.VhpageNumber = response.vhPageNumber;
            
            this.VhtotalPages =response.vhTotalPages;
            this.VhtotalRows = response.vhTotalRows
          } else {
            this.showErrorToast("unable to fetch data");
            console.log("unable to fetch data");
          }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },
     colorStyle(status){
      if(status==1)//Requested
      {return 'background-color:#03a9f3 ;border-color:#03a9f3';}
      else if(status==2)//Pending
      {return 'background-color:#03a9f3 ;border-color:#03a9f3';}
      else if(status==3)//Disputed
      {return 'background-color:black; border-color:black';}
      else if(status==4)//Paid
      {return 'background-color:#00C292; border-color:#00C292';}
      else if(status==5)//ReFund
      {return 'background-color:#dc3f4e; border-color:#dc3f4e';}
      else if(status==6)//PartiallyRefunded
      {return 'background-color:#DFCE1D; border-color:#DFCE1D';}
      else if(status==7)//PartiallyPaid
      {return 'background-color:#03a9f3; border-color:#03a9f3';}
      else if(status==7)//Deleted
      {return 'background-color:#03a9f3; border-color:#03a9f3';}
      else if(status==9)//Reconciled
      {return 'background-color:#d19e01; border-color:#d19e01';}
    },
     applySearchClick() {
      //debugger
       this.pageNumber = 1;
        this.loadInit();
      },
    changeVAL(){
     this.propPatientSource = { visitId: 0, patientId: 0, updButton: 1, ptid: "" }
    },
    loadInit() {
     //debugger
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
      };

      const url = this.SERVER + "/VNSPRAAPI/Patient/GetChckOutPat";
      this.axiosGetData(url, myData, 1);
      this.StartLogoutTime();
    },
    loadWitoutLoader() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
      };

      const url = this.SERVER + "/VNSPRAAPI/Patient/GetChckOutPat";
      this.axiosGetData(url, myData, 991);
      this.StartLogoutTime();
    },
    //code for Data-Tables_
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }

       if((this.showPagesMax/2) < (this.pageNumber))
        {
          this.showPagesMin = this.pageNumber-4;
          this.showPagesMax = this.pageNumber+4;
        }
        else if((this.showPagesMin/2)<(this.pageNumber))
        {
          this.showPagesMin = this.pageNumber-4;
          this.showPagesMax = this.pageNumber+4 ;
          if(this.showPagesMax<5)
          {
            this.showPagesMax = 5;
          }
        }
        else{
          this.showPagesMin = 1;
          this.showPagesMax = 5 ;
        }
      this.loadInit();
    },
    orderByPay(column){
      this.orderByCol = column;
      if(column==1)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx < b.pndx) ? 1 : ((b.pndx < a.pndx) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx > b.pndx) ? 1 : ((b.pndx > a.pndx) ? -1 : 0))
        }
        
      }
      if(column==2)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx < b.pndx) ? 1 : ((b.pndx < a.pndx) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx > b.pndx) ? 1 : ((b.pndx > a.pndx) ? -1 : 0))
        }
      }
      if(column==3)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx < b.pndx) ? 1 : ((b.pndx < a.pndx) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx > b.pndx) ? 1 : ((b.pndx > a.pndx) ? -1 : 0))
        }
      }
      if(column==4)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billNo < b.billNo) ? 1 : ((b.billNo < a.billNo) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billNo > b.billNo) ? 1 : ((b.billNo > a.billNo) ? -1 : 0))
        }
      }
      if(column==5)
      {
      if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx < b.pndx) ? 1 : ((b.pndx < a.pndx) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx > b.pndx) ? 1 : ((b.pndx > a.pndx) ? -1 : 0))
        }
      }
      if(column==6)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billDateStr < b.billDateStr) ? 1 : ((b.billDateStr < a.billDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billDateStr > b.billDateStr) ? 1 : ((b.billDateStr > a.billDateStr) ? -1 : 0))
        }
      }
      if(column==7)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billDateStr < b.billDateStr) ? 1 : ((b.billDateStr < a.billDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billDateStr > b.billDateStr) ? 1 : ((b.billDateStr > a.billDateStr) ? -1 : 0))
        }
      }
     if(column==8)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.amount < b.amount) ? 1 : ((b.amount < a.amount) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.amount > b.amount) ? 1 : ((b.amount > a.amount) ? -1 : 0))
        }
      }
        if(column==9)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.amount < b.amount) ? 1 : ((b.amount < a.amount) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.amount > b.amount) ? 1 : ((b.amount > a.amount) ? -1 : 0))
        }
      }
        if(column==10)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.refundDateStr < b.refundDateStr) ? 1 : ((b.refundDateStr < a.refundDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.refundDateStr > b.refundDateStr) ? 1 : ((b.refundDateStr > a.refundDateStr) ? -1 : 0))
        }
      }
        if(column==11)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.comment < b.comment) ? 1 : ((b.comment < a.comment) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.comment > b.comment) ? 1 : ((b.comment > a.comment) ? -1 : 0))
        }
      }
    },
    orderBy(column) {
      if (this.sortColumn == column) {
        switch (this.sortColumnOption) {
          case 0:
            this.sortColumnOption = 1;
            break;
          case 1:
            this.sortColumnOption = 2;
            break;
          case 2:
            this.sortColumn = 0;
            this.sortColumnOption = 0;
            break;
        }
      } else {
        this.sortColumn = column;
        this.sortColumnOption = 1;
      }
      this.pageNumber = 1;
      this.loadInit();
    },

    orderByRemeber(column) {
     //debugger
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.firstName < b.firstName ? 1 : b.firstName < a.firstName ? -1 : 0
          );
        } else {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.lastName > b.lastName ? 1 : b.lastName > a.lastName ? -1 : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.visitType < b.visitType ? 1 : b.visitType < a.visitType ? -1 : 0
          );
        } else {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.visitType > b.visitType ? 1 : b.visitType > a.visitType ? -1 : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.dos < b.dos
              ? 1
              : b.dos < a.dos
              ? -1
              : 0
          );
        } else {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.dos > b.dos
              ? 1
              : b.dos > a.dos
              ? -1
              : 0
          );
        }
      }
           if (column == 3) {
        if (this.asc_desc == "asc") {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.CheckedoutLocalDate < b.CheckedoutLocalDate
              ? 1
              : b.CheckedoutLocalDate < a.CheckedoutLocalDate
              ? -1
              : 0
          );
        } else {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.CheckedoutLocalDate > b.CheckedoutLocalDate
              ? 1
              : b.CheckedoutLocalDate > a.CheckedoutLocalDate
              ? -1
              : 0
          );
        }
      }
    },
handleRole(){
   this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
   this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
    if(this.EmployeeRolesStr.length > 0){
       this.val = this.EmployeeRolesStr.filter(
      (i)=>i.name == 'Check Out'
     );
       if(this.val[0].canUpdate == 0){ this.updButton = 0;}
       if(this.val[0].canDelete == 0){ this.delButton = 0;}
}
},

    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

  dropDownButtonClick_1(pat) {
        this.loader.hide();
        this.aSinglePatient = JSON.parse(JSON.stringify(pat));
        this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
        this.dummyComm.patientId = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Trackers/GetChckOutPatIns";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 47);
    },
  
    dropDownButtonClick(pat, button) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.aSinglePatient.insurance = pat.insurances;
      this.p_visitId = pat.visitId;
      this.button_Name = button;
      this.showDropDownModal = true;
    },

   dropdownModalClosed(val) {
      this.showDropDownModal = val;
    },
 closeModalRem() {
      this.displayPayMethod = false;
    },
// for delete
  requestDeleteClick(pat) {
   //debugger
    Swal.fire({
        icon: "error",
        title: "Are you sure?",
        text: "you want to delete this visit and any information related to it.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          //const dd = new Date();
          this.intDummyComm();
          this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
          this.dummyComm.visitId = pat.visitId;
          this.dummyComm.pageNumber = this.pageNumber;
          this.dummyComm.pageSize = this.pageSize;
          this.dummyComm.filter = "";

          const myData = {
            dc: this.dummyComm,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };
          const url = this.SERVER + "/VNSPRAAPI/Trackers/DelPatientCheckOut";
          this.axiosGetData(url, myData, 46);
        }
      });
    },

    phyAssignedClick(phy) {
      //this.clearPhysicianAssignment();
      this.aSinglePatient.allotedPhysicianId = phy.userId;
      phy.isAlloted = 1;
      let xx = this.allFilterPatientsCheck.find(
        (f) => f.pndx == this.aSinglePatient.pndx
      );
      xx.allotedPhysicianId = phy.userId;
      xx.isAlloted = 1;
      const dd = new Date();
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.NextStageId = 0;
      this.dummyComm.StageId = this.stageId;
      //********Stageid
      this.dummyComm.modelFrom = 1;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.filter = "";

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sort: this.mainSort,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdPhyCheckout";
      this.dummyComm.extras = this.mixinMakeCommString(
        this.aSinglePatient.pndx,
        phy.userId,
        dd.toLocaleDateString() + " " + dd.toLocaleTimeString()
      );
      // const myData = { dc: this.dummyComm, patientInfo: this.aSinglePatient };
      this.axiosGetData(url, myData, 99);
    },

    //--$$**$$
    showPatientProfilePopup(pay) {
      if (pay.visitId > 0 || pay.patientId > 0) {
       //debugger
        this.propPatientSource.visitId = pay.visitId;
        this.propPatientSource.patientId = pay.patientId;
        this.propPatientSource.updButton = this.updButton;
        this.propPatientSource.ptid = pay.ptid;
        $("#newptModal").modal("show");
      }
    },
    showProfilPopUpBro(pat) {
      console.log(pat);
      this.showProfilePopupVar = true;
    
      this.$nextTick(() => {
        $("#newptModalCom").modal("show");    
        this.$refs.patientComponent.getPatientData(pat);  
        this.removeModalBackdrop();
      });   
    },
    removeModalBackdrop(){
      this.$nextTick(() => {
            debugger;
            $("#newptModalCom").on("shown.bs.modal", function (e) {
            $(document).off("focusin.modal");
        });
      });
    }, 

    //--**
    questionModalClick(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetVisQueDat";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData, 30);
    },

    questSaveClick() {
      for (var k = 0; k < this.visitQuests.length; k++) {
        // if(this.visitQuests[k].answer == "") {
        //     this.ShowWarning("All Questionnaire Input is require");
        //     return;
        // }
        if (this.visitQuests[k].questTypeName == "Phone Number") {
          if (this.visitQuests[k].answer.length < 12) {
            this.ShowWarning("Phone must be of 10 length");
            return;
          }
        }
        if (this.visitQuests[k].questTypeName == "Date") {
          if (!this.isValidateDate(this.visitQuests[k].answer)) {
            this.ShowWarning("Valid Date of Birth required");
            event.preventDefault();
            return;
          }
        }
        if (this.visitQuests[k].questTypeName == "Email") {
          if (this.visitQuests[k].answer != null) {
            if (!this.validEmail(this.visitQuests[k].answer)) {
              this.Validity(this.e);
            }
          }
        }
      }
      this.intDummyComm();
     //debugger // eslint-disable-line no-debugger
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;

      //this.dummyComm.extras = this.aSelectedPatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdVisQue";
      const myData = {
        dc: this.dummyComm,
        quests: this.visitQuests,
      };

      this.axiosGetData(url, myData, 31);
    },

    commentLeftClick() {
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetCommentsList";
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.axiosGetData(url, this.dummyComm, 33);
    },

    leaveCommentSaveClick() {
      if (this.commentText.length < 1) {
        this.ShowWarning("Comment is require");
        event.preventDefault();
        return;
      }

      const url = this.SERVER + "/VNSPRAAPI/Trackers/SaveComment";
      this.intDummyComm();
      this.dummyComm.extras = this.commentText;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.axiosGetData(url, this.dummyComm, 34);
    },

    showCommentLine(ndx) {
      const xx = this.commentsList.length - 1;
      if (ndx < xx) return true;
      else return false;
    },

    editVisitTypeClick(pat) {
      this.visitTypes = [];
      this.visitReasons = [];
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.aSinglePatient.dosStr = this.aSinglePatient.dos.split("T")[0];

      this.intDummyComm();
      this.dummyComm.extras = pat.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTypRea";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData, 35);
    },

    collectPaymentClick(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      $("#paymentMethod").modal("show");
      
      this.requestPaymentClick_3(this.aSinglePatient, 0);
    },

    savePaymentRequest() {
      var valueAmount = String(this.aSingleRequestPayment.amount);
      if (this.aSingleRequestPayment.phone == "") {
        this.ShowWarning("Phone is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleRequestPayment.phone.length < 12) {
        this.ShowWarning("Phone length must be 10");
        event.preventDefault();
        return;
      }
      if (this.aSingleRequestPayment.email == "") {
        this.ShowWarning("Email is require");
        event.preventDefault();
        return;
      }
      if (valueAmount == "") {
        this.ShowWarning("Amount is require");
        event.preventDefault();
        return;
      }
      if (valueAmount < 0) {
        this.ShowWarning("Invalid Amount");
        event.preventDefault();
        return;
      }
      if (
        valueAmount.indexOf(".") > -1 &&
        this.aSingleRequestPayment.amount.split(".")[1].length > 2
      ) {
        this.ShowWarning("Amount allow with two decimal places");
        event.preventDefault();
        return;
      }
      if (this.aSingleRequestPayment.comment == "") {
        this.ShowWarning("Comment is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleRequestPayment.email != null) {
        if (!this.validEmail(this.aSingleRequestPayment.email)) {
          this.Validity(this.e);
        }
      }
      //this.aSingleRequestPayment.fndx = this.aSinglePatient.pndx;
      this.aSingleRequestPayment.visitId = this.aSinglePatient.visitId;

      this.intDummyComm();
      //const dd = new Date();
     //debugger // eslint-disable-line no-debugger
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.aSingleRequestPayment.patientId = this.aSinglePatient.patientId;

      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

      this.dummyComm.extras = this.dateToLocalString(new Date());
      this.dummyComm.myDate = this.dateToLocalString(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayReq";
      const myData = {
        dc: this.dummyComm,
        pr: this.aSingleRequestPayment,
      };

      this.axiosGetData(url, myData, 37);
    },

    sendEmailClick(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData, 41);
    },

    sendText1Click(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      console.log(pat);
      if (this.smsTempsList.length <= 0) {
        this.intDummyComm();

        const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTxtTem";
        this.dummyComm.extras = new String(pat.patientid);
        const myData = this.dummyComm;

        this.axiosGetData(url, myData, 39);
      } else $("#sendText1").modal({ backdrop: "static", keyboard: false });
    },

    sendText1ModalClose() {
      $("#sendText1").modal("hide");
    },

    selectedEmailTempIcon(email) {
      if (email.emailTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },

    selectedEmailTempClass(email) {
      if (email.emailTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.aSingleEmail.emailTemplateId == email.emailTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },

    emailTempsListClick(email) {
      this.aSingleEmail.emailTemplateId = email.emailTemplateId;
      if (email.emailTemplateId > 0)
        this.aSingleEmail = JSON.parse(JSON.stringify(email));
      else
        this.aSingleEmail = {
          name: "",
          emailTemplateId: 0,
          emailSubject: "",
          email: "",
          emailText: "",
        };
    },

    getPatientInfo(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      var date = moment(String(this.aSinglePatient.dosdate)).format(
        "YYYY-MM-DD"
      );
      this.aSinglePatient.dob = date;
      this.intDummyComm();
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Patient/GetSinglePatientData";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 14);
    },

 loader_1() {
    this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });
 },

    sendEmail() {
      if (this.aSingleEmail.name == "") {
        this.ShowWarning("Name is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email == "") {
        this.ShowWarning("Email is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleEmail.emailText == "") {
        this.ShowWarning("Text is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleEmail.emailSubject == "") {
        this.ShowWarning("Subject is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }
      this.dummyComm.extras = "";

      const url = this.SERVER + "/VNSPRAAPI/Patient/SendEmail";
      const EmailData = {
        SentTo: this.aSinglePatient.email,
        SentFrom: "",
        Password: "",
        Body: this.aSingleEmail.emailText,
        Subject: this.aSingleEmail.emailSubject,
        TemplateName: this.aSingleEmail.name,
        UserId: this.dummyComm.ownerId,
        OwnerId: this.dummyComm.ownerId,
        PracticeId: this.dummyComm.practiceId,
        PatientId: this.aSinglePatient.patientId,
        VisitId: this.aSinglePatient.visitId,
        SentLocal: new Date(),
        //SentServer:
      };
      const myObject = {
        dc: this.dummyComm,
        email: EmailData,
      };

      this.axiosGetData(url, myObject, 42);
    },

    SendSms() {
      if (this.aSingleSms.name == "") {
        this.ShowWarning("Name is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.phone == "") {
        this.ShowWarning("Phone is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleSms.smsText == "") {
        this.ShowWarning("Text is require");
        event.preventDefault();
        return;
      }
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendSMS";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      const dc = this.dummyComm;
      const Sms = {
        PhoneNumber: this.aSinglePatient.phone,
        MessageBody: this.aSingleSms.smsText,
        PatientID: this.aSinglePatient.patientId,
        UserId: 0,
        VisitId: 0,
        LocalTime: new Date(),
      };
      const myData = {
        dc: dc,
        Sms: Sms,
      };

      this.axiosGetData(url, myData, 40);
    },

    selectedSmsTempClass(sms) {
      if (sms.smsTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.selectedSmsId == sms.smsTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },

    selectedSmsTempIcon(sms) {
      if (sms.smsTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },

    smsTempsListClick(sms) {
      this.selectedSmsId = sms.smsTemplateId;
      if (sms.smsTemplateId > 0)
        this.aSingleSms = JSON.parse(JSON.stringify(sms));
      else this.aSingleSms = { name: "", smsTemplateId: 0, smsText: "" };
    },

    updatePatientTypeReasonClick() {
      if (!this.isValidateDate(this.aSinglePatient.dosStr)) {
        this.ShowWarning("Valid Date is required");
        event.preventDefault();
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: "After changing the Visit Type/Reason Old Questionnaire & their Answers will be lost. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Change",
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = "";
          //let dd = new Date(this.aSinglePatient.dos);
          //this.aSinglePatient.dosStr =
          //dd.toISOString().slice(0, 10) + " " + dd.toLocaleTimeString();
          const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdPatTypRea";
          const myData = {
            dc: this.dummyComm,
            patientInfo: this.aSinglePatient,
          };

          this.axiosGetData(url, myData, 37);
        }
      });
    },

    assignPhysicianClick(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));

      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetPhyLst";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData, 43);
    },

    mergeModalClick(pat) {
      $("#mappingClick").click();
      if (typeof pat !== "undefined") {
        this.aSinglePatient = JSON.parse(JSON.stringify(pat));
        this.aSinglePatient.insurance = pat.insurances;
        if (this.aSinglePatient.ptid !== null) {
          this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
        }
      }

      this.intDummyComm();
      this.dummyComm.extras = "nFilter";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested.searchVeinsId,
        externalId: "",
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        phone: this.aSinglePatient.phone,
        email: this.aSinglePatient.email,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.dateToYMD(this.aSinglePatient.dob),
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      this.mergeModalAxois(url, myData, 4);
    },
    async mergeModalAxois(url, myData, what)
    {
        var loader = this.$loading.show({
          color: "#03a9f3",
        });
       await axios({
        method: "post",
        data:myData,
        url: url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
            debugger;
            this.totalRowsSuggest = res.data.dc.totalRow;
            this.totalPagesSuggest = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let i = 0; i < this.allPatients.length; i++) {
              const dd = new Date(this.allPatients[i].dob);
              this.allPatients[i].dob = dd.toLocaleDateString();
              //this.allPatients[i].dobd = dd;
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients;
            for (var i = 0; i < this.suggestedPatients.length; i++) {
              if (this.suggestedPatients[i].ptid !== null) {
                this.suggestedPatients[i].ptid = this.suggestedPatients[
                  i
                ].ptid.replace(/ /g, "");
              }
            }
            $("#mergeModal").modal("show");
        })
        .catch(function(error) {
          //alert(console.log(error));
        })
        .finally(() => { loader.hide();});
    },
     checkPatient(pat) {
     //debugger
      this.aSelectedPatient = JSON.parse(JSON.stringify(pat));
      this.dummyComm.extras2 = this.aSinglePatient.dos;
      this.dummyComm.pure = this.aSinglePatient.visitId;

      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId;
      const url = this.SERVER + "/STDS/StageDisplay/CheckVisitPat";
      this.dummyComm.extras1 = pat.patientId;
      const myData = this.dummyComm;
      this.checkPatientAxios(url, myData, 7000);
    },
    async checkPatientAxios(url, myData, what)
    {
        var loader = this.$loading.show({
          color: "#03a9f3",
        });
       await axios({
        method: "post",
        data:myData,
        url: url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          console.log(res.data);
          debugger;
            if (res.data.extras === "0") {
              this.alertModalClick_Suggested();
            } else {
              this.showMergeSwal();
            }
        })
        .catch(function(error) {
          //alert(console.log(error));
        })
        .finally(() => { loader.hide();});
    },
     showMergeSwal() {
      Swal.fire({
        title: "Are you sure?",
        text:
          "This Patient already has a visit for this Date of Service. Do you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          this.alertModalClick_Suggested();
        }
      });
    },
     mergeContinueClick() {
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      if (this.mergedPat.firstName == "") {
        this.ShowWarning("First Name is require");
        event.preventDefault();
        return;
      } else if (this.mergedPat.lastName == "") {
        this.ShowWarning("Last Name is require");
        event.preventDefault();
        return;
      } else if (this.mergedPat.gender == 0) {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      } else if (!this.isValidateDate(this.mergedPat.dob)) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      }
      // else if (this.mergedPat.phone == "") {
      //   this.ShowWarning("Phone is require");
      //   event.preventDefault();
      //   return;
      // } else if(this.mergedPat.ssn == ""){
      //   this.ShowWarning("SSN is require");
      //    event.preventDefault();
      //    return;
      //}
      // else if (this.mergedPat.address == "") {
      //   this.ShowWarning("Street Address is require");
      //   event.preventDefault();
      //   return;
      // }
      // else if (this.mergedPat.city == "") {
      //   this.ShowWarning("City is require");
      //   event.preventDefault();
      //   return;
      // }
      // else if (this.mergedPat.State == "") {
      //   this.ShowWarning("State is require");
      //   event.preventDefault();
      //   return;
      // }
      // else if (this.mergedPat.zip == "") {
      //   this.ShowWarning("Zip is require");
      //   event.preventDefault();
      //   return;
      // }
      Swal.fire({
        title: "Are you sure?",
        text:
          "After you merge these profiles. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Merge",
      }).then((result) => {
        if (result.value) {
          const dd = new Date();
          this.intDummyComm();
          this.dummyComm.visitId = this.aSinglePatient.visitId;
          this.dummyComm.patientId = this.aSinglePatient.patientId;
          this.dummyComm.MyDate = new Date().toJSON();
          //**$$**
          this.aSinglePatient.firstName = this.mergedPat.firstName;
          this.aSinglePatient.lastName = this.mergedPat.lastName;
          //;
          this.aSinglePatient.dob = this.mergedPat.dob;
          this.aSinglePatient.gender = this.mergedPat.gender;
          this.aSinglePatient.phone = this.mergedPat.phone;
          this.aSinglePatient.email = this.mergedPat.email;
          this.aSinglePatient.ssn = this.mergedPat.ssn;
          this.aSinglePatient.address = this.mergedPat.address;
          this.aSinglePatient.city = this.mergedPat.city;
          this.aSinglePatient.state = this.mergedPat.state;
          this.aSinglePatient.externalId = this.mergedPat.externalId;
          this.aSinglePatient.zip = this.mergedPat.zip;
          this.aSinglePatient.insurance.primaryInsurance = this.mergedPat.primaryIns;
          this.aSinglePatient.insurance.primaryInsuranceNo = this.mergedPat.primaryInsNo;
          this.aSinglePatient.insurance.primaryInsuranceId = this.mergedPat.primaryInsId;
          this.aSinglePatient.insurance.primaryInsuranceGroupId = this.mergedPat.primaryInsGroupId;
          this.aSinglePatient.insurance.secondaryInsurance = this.mergedPat.secondIns;
          this.aSinglePatient.insurance.secondaryInsuranceNo = this.mergedPat.secondInsNo;
          this.aSinglePatient.insurance.secondaryInsuranceId = this.mergedPat.secondInsId;
          this.aSinglePatient.insurance.secondaryInsuranceGroupId = this.mergedPat.secondInsGroupId;
          //**$$**
          this.dummyComm.pageNumber = this.pageNumber;
          this.dummyComm.pageSize = this.pageSize;
          this.dummyComm.extras =
            this.aSelectedPatient.patientId +
            this.UKEY +
            dd.toLocaleDateString() +
            " " +
            dd.toLocaleTimeString();

          const darr = this.currentDateRange.split(" to ");
          let startDate = "";
          let endDate = "";

          if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
          else startDate = new Date(darr[0]);
          endDate = new Date(darr[1]);

          const filter = {
            veinsId: this.mainSearch.searchVeinsId,
            externalId: this.mainSearch.searchExternalId,
            firstName: this.mainSearch.searchFirstName,
            lastName: this.mainSearch.searchLastName,
            phone: this.mainSearch.searchPhone,
            startDate: this.dateToYMD(startDate) + "",
            endDate: this.dateToYMD(endDate) + "",
            stageId: this.stageId,
          };

         //debugger
          const url = this.SERVER + "/VNSPRAAPI/Trackers/MerPat";
          const myData = {
            dc: this.dummyComm,
            pat: this.aSinglePatient,
            ins: this.aSinglePatient.insurance,
            filter: filter,
            sort: this.mainSort,
          };
          this.axiosGetData(url, myData, 5);          
        }
      });
    },
    applyDateClickSuggested1() {
      const str = this.suggested1.Dob;
      const arr = str.split("-");
      let three = arr[0].slice(0, 3);
      let two = arr[0].slice(0, 2);
      let one = arr[0].slice(0, 1);
      if (three === "000" || two === "00" || one === "0") {
        return;
      }

      this.pageNumberSuggest1 = 1;
      this.mergeModalClickReload1();
    },
    pageChangeSuggested1(obj) {
      if (obj == "Next") {
        if (this.pageNumberSuggest1 < this.totalPagesSuggest1) {
          this.pageNumberSuggest1 += 1;
        }
      } else if (obj == "Previous" && this.pageNumberSuggest1 != 1) {
        this.pageNumberSuggest1 -= 1;
      } else {
        this.pageNumberSuggest1 = obj;
      }

      if (this.showPagesMax1 / 2 < this.pageNumberSuggest1) {
        this.showPagesMin1 = this.pageNumberSuggest1 - 4;
        this.showPagesMax1 = this.pageNumberSuggest1 + 4;
      } else if (this.showPagesMin1 / 2 < this.pageNumberSuggest1) {
        this.showPagesMin1 = this.pageNumberSuggest1 - 4;
        this.showPagesMax1 = this.pageNumberSuggest1 + 4;
        if (this.showPagesMax1 < 5) {
          this.showPagesMax1 = 5;
        }
      } else {
        this.showPagesMin1 = 1;
        this.showPagesMax1 = 5;
      }

      this.mergeModalClickReload1();
    },
    mergeModalClickReloadChange() {
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }

      this.intDummyComm();
      this.dummyComm.extras = "nFilter";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";
      var filter = {};
      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      if (
        this.suggested.searchVeinsId == "" &&
        this.suggested.searchExternalId == "" &&
        this.suggested.searchFirstName == "" &&
        this.suggested.searchLastName == "" &&
        this.suggested.searchPhone == "" &&
        this.suggested.Dob == ""
      ) {
        filter = {
          veinsId: this.suggested.searchVeinsId,
          externalId: "",
          firstName: this.aSinglePatient.firstName,
          lastName: this.aSinglePatient.lastName,
          phone: this.aSinglePatient.phone,
          email: this.aSinglePatient.email,
          startDate: this.dateToYMD(startDate) + "",
          endDate: this.dateToYMD(endDate) + "",
          Dob: this.dateToYMD(this.aSinglePatient.dob),
          stageId: 0,
        };
      } else {
        filter = {
          veinsId: this.suggested.searchVeinsId,
          externalId: this.suggested.searchExternalId,
          firstName: this.suggested.searchFirstName,
          lastName: this.suggested.searchLastName,
          phone: this.suggested.searchPhone,
          startDate: this.dateToYMD(startDate) + "",
          endDate: this.dateToYMD(endDate) + "",
          Dob: this.suggested.Dob,
          stageId: 0,
        };
      }

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      this.axiosGetData(url, myData, 400);
    },
    orderBySuggested1(column) {
      if (this.sortColumnSuggest1 == column) {
        switch (this.sortColumnOptionSuggest1) {
          case 0:
            this.sortColumnOptionSuggest1 = 1;
            break;
          case 1:
            this.sortColumnOptionSuggest1 = 2;
            break;
          case 2:
            this.sortColumnSuggest1 = 0;
            this.sortColumnOptionSuggest1 = 0;
            break;
        }
      } else {
        this.sortColumnSuggest1 = column;
        this.sortColumnOptionSuggest1 = 1;
      }
      this.pageNumberSuggest = 1;
      this.mergeModalClickReload1();
    },
     mergeModalClickReload1() {
     //debugger
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest1;
      this.dummyComm.pageSize = this.pageSizeSuggest1;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

     //debugger
      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested1.searchVeinsId,
        externalId: this.suggested1.searchExternalId,
        firstName: this.suggested1.searchFirstName,
        lastName: this.suggested1.searchLastName,
        phone: this.suggested1.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.suggested1.Dob,
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest1,
        sortColumnOption: this.sortColumnOptionSuggest1,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPage";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      this.mergeModalReloadAxios(url, myData, 500);
    },
    async mergeModalReloadAxios(url, myData, what)
    {
        var loader = this.$loading.show({
          color: "#03a9f3",
        });
       await axios({
        method: "post",
        data:myData,
        url: url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
        }).then((res) => {
            //this.loader.hide();
            this.totalRowsSuggest1 = res.data.dc.totalRow;
            this.totalPagesSuggest1 = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let k = 0; k < this.allPatients.length; k++) {
              const dd = new Date(this.allPatients[k].dob);
              this.allPatients[k].dob = dd.toLocaleDateString();
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients1 = this.allPatients;
            for (let j = 0; j < this.suggestedPatients1.length; j++) {
              if (this.suggestedPatients1[j].ptid !== null) {
                this.suggestedPatients1[j].ptid = this.suggestedPatients1[
                  j
                ].ptid.replace(/ /g, "");
              }
            }
        }).catch(function(error) {
          //alert(console.log(error));
        }).finally(() => { loader.hide();});
    },
    refundPayment() {
    this.intDummyComm();
    this.dummyComm.patientId = this.aSinglePatient.patientId;
    const url =
    this.SERVER + "/VNSPRAAPI/Payments/RefundPayment";
    const myData = { 
      DC: this.dummyComm,
      BillNo:this.ActivePaymentRequest.billNo,
      DateLocalTime: new Date,
      RefundMethod: this.refundMethodType,
      Amount: this.refundAmount        
    }
      this.axiosGetData(url, myData, 9003);
    },
   showSubmitRefundModal(pay){
      this.ActivePaymentRequest = pay;
      this.refundMethodType = pay.paymentMethod;
      $('#displayReceipt11').modal("show");
    },
    mergePatientInputStyle() {
      return "background-color: transparent;border-style: none;width: 100%;margin: 0px;padding:0px;";
    },

    alertModalClick_Suggested() {
     //debugger
      //this.aSelectedPatient = JSON.parse(JSON.stringify(pat));
      //remove spaces
      debugger;
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }

      const obj = this.allInsurances.filter(
        (f) => f.patientId == this.aSelectedPatient.patientId
      );
      const obj1 = this.VisitPayCounts.filter(
        (f) => f.patientId == this.aSelectedPatient.patientId
      );
      ////console.log(obj);
      this.aSelectedCounts = {
        VisitCounts: 0,
        PaymentCounts: 0,
        EmailCounts: 0,
        TextCounts: 0,
      };
      this.aSelectedInsurance = {
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceId: "",
        primaryInsuranceGroupId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceId: "",
        secondaryInsuranceGroupId: "",
      };
      if (obj.length > 0) {
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].isPrimary == 1) {
            this.aSelectedInsurance.primaryInsurance = obj[i].insuranceName;
            this.aSelectedInsurance.primaryInsuranceNo = obj[i].insuranceNo;
            this.aSelectedInsurance.primaryInsuranceId = obj[i].insuranceId;
            this.aSelectedInsurance.primaryInsuranceGroupId =
              obj[i].insuranceGroupId;
          } else {
            this.aSelectedInsurance.secondaryInsurance = obj[i].insuranceName;
            this.aSelectedInsurance.secondaryInsuranceNo = obj[i].insuranceNo;
            this.aSelectedInsurance.secondaryInsuranceId = obj[i].insuranceId;
            this.aSelectedInsurance.secondaryInsuranceGroupId =
              obj[i].insuranceGroupId;
          }
        }
      }
      if (obj1.length > 0) {
        for (let j = 0; j < obj1.length; j++) {
          this.aSelectedCounts.VisitCounts = obj1[j].visits;
          this.aSelectedCounts.PaymentCounts = obj1[j].payments;
          this.aSelectedCounts.EmailCounts = obj1[j].emails;
          this.aSelectedCounts.TextCounts = obj1[j].texts;
        }
      }
      // *$$*
      const arr = this.aSelectedPatient.dob.split("/");
      const dd = new Date(arr[2], arr[0] - 1, arr[1]);
      if (this.aSinglePatient.phone == "") {
        this.phone = this.aSelectedPatient.phone;
      } else {
        this.phone = this.aSinglePatient.phone;
      }
      if (this.aSinglePatient.email == "") {
        this.email = this.aSelectedPatient.email;
      } else {
        this.email = this.aSinglePatient.email;
      }
      if (this.aSinglePatient.ssn == "") {
        this.ssn = this.aSelectedPatient.ssn;
      } else {
        this.ssn = this.aSinglePatient.ssn;
      }
      if (this.aSinglePatient.address == "") {
        this.address = this.aSelectedPatient.streetAddress;
      } else {
        this.address = this.aSinglePatient.address;
      }
      if (this.aSinglePatient.city == "") {
        this.city = this.aSelectedPatient.city;
      } else {
        this.city = this.aSinglePatient.city;
      }
      if (this.aSinglePatient.state == "") {
        this.state = this.aSelectedPatient.state;
      } else {
        this.state = this.aSinglePatient.state;
      }
      if (this.aSinglePatient.zip == "") {
        this.zip = this.aSelectedPatient.zip;
      } else {
        this.zip = this.aSinglePatient.zip;
      }
      if (this.aSinglePatient.insurance.primaryInsurance == "") {
        this.primaryInsurance = this.aSelectedInsurance.primaryInsurance;
      } else {
        this.primaryInsurance = this.aSinglePatient.insurance.primaryInsurance;
      }
      if (this.aSinglePatient.insurance.primaryInsuranceNo == "") {
        this.primaryInsuranceNo = this.aSelectedInsurance.primaryInsuranceNo;
      } else {
        this.primaryInsuranceNo = this.aSinglePatient.insurance.primaryInsuranceNo;
      }
      //no longer shown on front end
      if (this.aSinglePatient.insurance.primaryInsuranceId == "") {
        this.primaryInsuranceId = this.aSelectedInsurance.primaryInsuranceId;
      } else {
        this.primaryInsuranceId = this.aSinglePatient.insurance.primaryInsurance;
      }
      //no longer shown on front end

      if (this.aSinglePatient.insurance.primaryInsuranceGroupId == "") {
        this.primaryInsuranceGroupId = this.aSelectedInsurance.primaryInsuranceGroupId;
      } else {
        this.primaryInsuranceGroupId = this.aSinglePatient.insurance.primaryInsuranceGroupId;
      }

      if (this.aSinglePatient.insurance.secondaryInsurance == "") {
        this.secondaryInsurance = this.aSelectedInsurance.secondaryInsurance;
      } else {
        this.secondaryInsurance = this.aSinglePatient.insurance.secondaryInsurance;
      }
      if (this.aSinglePatient.insurance.secondaryInsuranceNo == "") {
        this.secondaryInsuranceNo = this.aSelectedInsurance.secondaryInsuranceNo;
      } else {
        this.secondaryInsuranceNo = this.aSinglePatient.insurance.secondaryInsuranceNo;
      }
      if (this.aSinglePatient.insurance.secondaryInsuranceId == "") {
        this.secondaryInsuranceId = this.aSelectedInsurance.secondaryInsuranceId;
      } else {
        this.secondaryInsuranceId = this.aSinglePatient.insurance.secondaryInsuranceId;
      }

      if (this.aSinglePatient.insurance.secondaryInsuranceGroupId == "") {
        this.secondaryInsuranceGroupId = this.aSelectedInsurance.secondaryInsuranceGroupId;
      } else {
        this.secondaryInsuranceGroupId = this.aSinglePatient.insurance.secondaryInsuranceGroupId;
      }

      if (
        this.aSinglePatient.externalId === "" ||
        this.aSinglePatient.externalId === null
      ) {
        this.externalId = this.aSelectedPatient.externalId;
      } else {
        this.externalId = this.aSinglePatient.externalId;
      }
      this.mergedPat = {
        firstName: this.aSelectedPatient.firstName,
        lastName: this.aSelectedPatient.lastName,
        dob: this.dateToYMD(dd),
        gender: this.aSelectedPatient.gender,
        phone: this.phone,
        email: this.email,
        externalId: this.externalId,
        ssn: this.ssn,
        address: this.address,
        city: this.city,
        state: this.state,
        zip: this.zip,
        primaryIns: this.primaryInsurance,
        primaryInsNo: this.primaryInsuranceNo,
        primaryInsId: this.primaryInsuranceId,
        primaryInsGroupId: this.primaryInsuranceGroupId,
        secondIns: this.secondaryInsurance,
        secondInsNo: this.secondaryInsuranceNo,
        secondInsId: this.secondaryInsuranceId,
        secondInsGroupId: this.secondaryInsuranceGroupId,
      };
      // *$$*
      $("#alertModal").modal("show");
    },

    updateDetailsClick() {
      //For validation
      if (this.aSinglePatient.firstName == "") {
        this.ShowWarning("Firstname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.lastName == "") {
        this.ShowWarning("Lastname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.dob == "") {
        this.ShowWarning("Date of Birth is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.gender == "0") {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      }
      if (!this.isValidateDate(this.aSinglePatient.dob)) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }

      const mainSort= {
        name: 0,
        dos: 0,
        visitType: 0,
        timein: 0,
      };
      const Patient = { 
        insurances : this.aSinglePatient.insurances,
        stats:this.aSinglePatient.stats,
        collection:this.aSinglePatient.collection,
        patientId: this.aSinglePatient.patientId,
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        patientName: this.aSinglePatient.patientName,
        visitId: this.aSinglePatient.visitId,
        dob: this.aSinglePatient.dob,
        visitTypeId: this.aSinglePatient.visitTypeId,
        externalId: this.aSinglePatient.externalId,
        visitType: this.aSinglePatient.visitType,
        visitReasonId: this.aSinglePatient.visitReasonId,
        visitReason: this.aSinglePatient.visitReason,
        reason: this.aSinglePatient.reason,
        physicianId: this.aSinglePatient.physicianId,
        ptid: this.aSinglePatient.ptid,
        physician: this.aSinglePatient.physician,
        dos: this.aSinglePatient.dos,
        cot: this.aSinglePatient.cot,
        timeIn: this.aSinglePatient.timeIn,
        gender: this.aSinglePatient.gender,
        ssn: this.aSinglePatient.ssn,
        phone: this.aSinglePatient.phone,
        email: this.aSinglePatient.email,
        address:this.aSinglePatient.address,
        city: this.aSinglePatient.city,
        state: this.aSinglePatient.state,
        zip: this.aSinglePatient.zip,
        checkedoutLocalDate: this.aSinglePatient.checkedoutLocalDate,
        timeInStr: this.aSinglePatient.timeInStr,
        dobStr: this.aSinglePatient.dobStr,
        cotStr: this.aSinglePatient.cotStr,
        dosStrTime: this.aSinglePatient.dosStrTime,
        dosStrDate: this.aSinglePatient.dosStrDate,
        cotStrTime: this.aSinglePatient.cotStrTime,
        cotStrDate: this.aSinglePatient.cotStrDate,
        Year: this.aSinglePatient.Year,
        Month: this.aSinglePatient.Month,
        Days: this.aSinglePatient.Days,
        checkedoutLocalTime: this.aSinglePatient.checkedoutLocalTime,
        actionString: this.aSinglePatient.actionString,
        insurance: {
            pndx: this.aSinglePatient.insurance.pndx,
            visitId: this.aSinglePatient.insurance.visitId,
            patientId: this.aSinglePatient.insurance.patientId,
            primaryInsurance: this.aSinglePatient.insurance.primaryInsurance,
            primaryInsuranceNo: this.aSinglePatient.insurance.primaryInsuranceNo,
            primaryInsuranceGroupId: this.aSinglePatient.insurance.primaryInsuranceGroupId,
            primaryInsuranceId: this.aSinglePatient.insurance.primaryInsuranceId,
            secondaryInsurance: this.aSinglePatient.insurance.secondaryInsurance,
            secondaryInsuranceNo: this.aSinglePatient.insurance.secondaryInsuranceNo,
            secondaryInsuranceGroupId: this.aSinglePatient.insurance.secondaryInsuranceGroupId,
            secondaryInsuranceId: this.aSinglePatient.insurance.secondaryInsuranceId,
            primaryFilePath: this.aSinglePatient.insurance.primaryFilePath,
            secondaryFilePath: this.aSinglePatient.insurance.secondaryFilePath,
            isPrimary: this.aSinglePatient.insurance.isPrimary,
            errorMessage: this.aSinglePatient.insurance.errorMessage
        }
      };
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SavePatientBasicInfoCheck";
      const myData = {
        dc: this.dummyComm,
        patientInfo: Patient,
        filter: this.$store.state.filterSTGDSP,
        sort: mainSort,
      };
      this.axiosGetData(url, myData, 16);
    },

    saveInsuranceClick() {
      if (this.insurance.primaryInsurance == "") {
        this.ShowWarning("Primary insurance require");
        return;
      } else if (this.insurance.primaryInsuranceNo == "") {
        this.ShowWarning("Primary insurance No require");
        return;
      } else if (this.insurance.primaryInsuranceGroupId == "") {
        this.ShowWarning("Primary insurance GroupId require");
        return;
      } else if (this.insurance.secondaryInsurance == "") {
        this.ShowWarning("Secondary insurance require");
        return;
      } else if (this.insurance.secondaryInsuranceNo == "") {
        this.ShowWarning("Secondary insurance No require");
        return;
      } else if (this.insurance.secondaryInsuranceGroupId == "") {
        this.ShowWarning("Secondary insurance GroupId  require");
        return;
      }
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;

      let obj = {
        pndx: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
      };
      var FirstFileName = $("#customFileLang_fl").html();
      var SecondFileName = $("#customFileLang_sl").html();

      obj = this.insurance;
      obj.fndx = this.aSinglePatient.pndx;
      obj.patientId = this.aSinglePatient.patientId;
      obj.primaryInsuranceId = FirstFileName;
      obj.secondaryInsuranceId = SecondFileName;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      obj.patientId = this.aSinglePatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Patient/SaveInsurancePatient";
      const myData = {
        dc: this.dummyComm,
        Insurance: obj,
      };

      this.axiosGetData(url, myData, 17);
    },
//
    showProfilePopup(pat, what) {
      //for Date Search filter
      this.endDate = new Date();
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 365);
      this.initDate_1 =
        this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);

      this.endDate_1 = new Date();
      this.startDate_1 = new Date();
      this.startDate_1.setDate(this.startDate_1.getDate() - 365);
      this.initDate =
        this.dateToMDY(this.startDate_1) +
        " - " +
        this.dateToMDY(this.endDate_1);

      this.endDate_2 = new Date();
      this.startDate_2 = new Date();
      this.startDate_2.setDate(this.startDate_2.getDate() - 365);
      this.initDate_2 =
        this.dateToMDY(this.startDate_2) +
        " - " +
        this.dateToMDY(this.endDate_2);

      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g,'');
      var date = moment(String(this.aSinglePatient.dob)).format(
        "YYYY-MM-DD"
      );
      this.aSinglePatient.dob = date;
      this.stdDate = moment(String(this.aSinglePatient.dob)).format("MM/DD/YYYY");
      this.intDummyComm();
      let url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 15);
      $("#detailsC").click();
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      url = this.SERVER + "/VNSPRAAPI/Patient/GetSnglPatAllData";
      myData = this.dummyComm;
      this.axiosGetData(url, myData, 14);

      if (what == "text") $("#textHistory1221").click();
      else if (what == "email") $("#emailtHistory1221").click();
      else if (what == "payment") $("#paymentHistory").click();
      //$("#newptModal").modal("show");
    },

    collectPaymentButtonClass(rp) {
      if (rp.status == "4") return "btn btn-success";
      else return "btn btn-danger";
    },

    collectPaymentButtonClassDropDown(rp) {
      if (rp.status == "4")
        return "btn btn-success btn btn-success dropdown-toggle dropdown-toggle-split";
      else
        return "btn btn-success  btn btn-danger dropdown-toggle dropdown-toggle-split";
    },

    isNumber(evt) {
      console.log("this a pressing");
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    requestPaymentClick_1() {
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetPayRequestPatient";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 38);
    },

 paymentReceivedClick(what) {
      const valueAmount = this.aSinglePaymentReceived.amount;

      if (what == "cheque") {

        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Cheque Number is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.showErrorToast("Card Number length must be 12");
          return;
        }
        if (this.aSinglePaymentReceived.holderName == 0) {
          this.showErrorToast("Holder name is require");
          return;
        }
        if (this.aSinglePaymentReceived.comment == 0) {
          this.showErrorToast("comment is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
        if(this.aSinglePaymentReceived.amount>this.limitAmount)
        {
          this.showErrorToast("Amount can not be greater then requested $" +this.limitAmount)
          return;
        }
      }
      if (what == "cash") {
        if (this.aSinglePaymentReceived.amount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      } else if (what == "credit-card") {
        if (this.aSinglePaymentReceived.cardCVC == "") {
          this.showErrorToast("Card CVC is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Card CVC must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.comment == "") {
          this.showErrorToast("Comment is require");
          return;
        }
        if (this.aSinglePaymentReceived.zip == "") {
          this.showErrorToast("Zip is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Zip must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Card Number is require");
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.showErrorToast("Card Number length must be 16");
          return;
        }
        if (this.aSinglePaymentReceived.holderName == "") {
          this.ShowWarning("Holder Name is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      }
      this.aSinglePaymentReceived.paymentMethod = what;
      this.aSinglePaymentReceived.visitId = this.aSinglePatient.visitId;
      this.aSinglePaymentReceived.patientId = this.aSinglePatient.patientId;
      this.aSinglePaymentReceived.pndx = this.ActivePaymentRequest.pndx;

      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayRec";
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
    
      const myData = { dc: this.dummyComm, pr: this.aSinglePaymentReceived };
      this.btnProColl = true;
      this.axiosGetData(url, myData, 12);
    },
   getPaymentEmailPhone(visitId) {
      this.intDummyComm();
      this.dummyComm.visitId = visitId;
      const myData = this.dummyComm;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailPhone";
      this.axiosGetData(url, myData , 189);
    },

    requestPaymentClick(pat, what) {
      if (what > 0) this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.patientId;
      this.PvisitId = pat.visitId;
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetPayRequestPatient";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 18);
    },

   requestPaymentClick_3(pat, what) {
      if (what > 0) this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetPayRequestPatient";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 188);
    },

    getIcon(id) {
      //console.log(id);
      if (id == 100) return "assets/images/actions/comment.png";
      else if (id == 50) return "assets/images/actions/edit.png";
      else if (id == 51) return "assets/images/actions/sent.png";
      else if (id == 300) return "assets/images/actions/credit-card.png";
      else if (id == 302) return "assets/images/actions/stethoscope.png";
      else if (id == 303) return "assets/images/actions/stethoscope.png";
      else if (id == 201) return "assets/images/actions/mapping.png";
      else if (id == 301) return "assets/images/actions/cash-money.png";
      else if (id == 400) return "assets/images/actions/steps1.png";
      else if (id == 304) return "assets/images/actions/patient.png";
    },

    GetAuditLog() {
      this.intDummyComm();
      this.dummyComm.myDate = "";
      //this.dummyComm.Extras = "";
      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetInitData2";
      this.axiosGetData(url, this.dummyComm, 21);
    },

    GetStagesList() {
      this.intDummyComm();
      //this.dummyComm.myDate = "";
      //this.dummyComm.Extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetStagesList";
      const myData = { dc: this.dummyComm };
      this.axiosGetData(url, myData, 29);
    },

    ClickOnStage(stage, pat) {
      Swal.fire({
        icon: "error",
        title: "Are you sure?",
        text:
          "you want to jump" +
          " " +
          pat.firstName + " " + pat.lastName +
          " " +
          "(" +
          pat.dob +
          ")" +
          " " +
          "to"+ " " + stage.name +"?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          //const dd = new Date();
          $("#v-" + pat.visitId + "").prop("disabled", true);
          this.intDummyComm();
          this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
          this.dummyComm.visitId = pat.visitId;
          this.dummyComm.stageId = stage.stageId;
          this.dummyComm.patientId = pat.patientId;

          this.dummyComm.pageNumber = this.pageNumber;
          this.dummyComm.pageSize = this.pageSize;
          this.dummyComm.filter = "";

          const myData = {
            dc: this.dummyComm,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };
          
          const url = this.SERVER + "/VNSPRAAPI/Trackers/CheckoutRollback";
          this.axiosGetData(url, myData, 32);
        }
      });
    },

    allPatientsClick() {
      this.filterFirstName = "";
      this.filterLastName = "";
      this.filterPhone = "";
      this.filterDate = "";
      this.filterDDate = "";
      this.filterSearchList();
    },

    suggestedClick() {
      const obj = this.aSinglePatient;
      this.suggestedPatients = this.allPatients.filter(
        (f) =>
          f.firstName.toLowerCase() == obj.firstName.toLowerCase() ||
          f.lastName.toLowerCase() == obj.lastName.toLowerCase() ||
          f.ssn == obj.ssn ||
          f.phone == obj.phone ||
          f.email.toLowerCase() == obj.email.toLowerCase()
      );
    },

    filterSearchList() {
      try {
        let dd = new Date(this.filterDate);
        let ds = dd.toLocaleDateString();
        if (dd == "Invalid Date" || dd.getFullYear() < 1900) {
          this.suggestedPatients = this.allPatients.filter(
            (f) =>
              f.firstName
                .toLowerCase()
                .startsWith(this.filterFirstName.toLowerCase()) &&
              f.lastName
                .toLowerCase()
                .startsWith(this.filterLastName.toLowerCase()) &&
              f.phone.startsWith(this.filterPhone)
          );
        } else {
          this.suggestedPatients = this.allPatients.filter(
            (f) =>
              f.firstName
                .toLowerCase()
                .startsWith(this.filterFirstName.toLowerCase()) &&
              f.lastName
                .toLowerCase()
                .startsWith(this.filterLastName.toLowerCase()) &&
              f.phone.startsWith(this.filterPhone) &&
              f.dob == ds
          );
        }
      } catch {
        this.suggestedPatients = this.allPatients.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(this.filterFirstName.toLowerCase()) &&
            f.lastName
              .toLowerCase()
              .startsWith(this.filterLastName.toLowerCase()) &&
            f.phone.startsWith(this.filterPhone)
        );
      }
    },

    clearPhysicianAssignment() {
      for (let i = 0; i < this.phyList.length; i++) {
        this.phyList[i].isAlloted = 0;
        const dd = new Date(this.phyList[i].dob);
        this.phyList[i].dob = dd.toLocaleDateString();
      }
    },

    getActiveVisitReasons(id) {
      this.activeVisitReasons = [];
      this.activeVisitReasons = this.visitReasons.filter(
        (f) => f.visitTypeId == id
      );

      if (this.activeVisitReasons.length > 0)
        this.aSinglePatient.visitDetailId =
          this.activeVisitReasons[0].visitDetailId;
    },

    //-----------------------------------------------------------------------------------------------------------------
    async axiosGetData(URL, Data, what) {
       if (what === 32 || what === 29 || what === 991) {
        //console.log("ok");
      } else {
        var loader = this.$loading.show({
          color: "#03a9f3",
        });
      }
      await axios({
        method: "post",
        url: URL,
        data: Data,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          //loader.hide();
          // if everything goes well -- we will get data
          if (what === 1) {
            if (res.data.dc.auditFlag === 1) {
              this.checkoutPatients = res.data.patients;
              this.allFilterPatientsCheck = res.data.patients;
              this.totalRows = res.data.dc.totalRow;
              this.totalPages = res.data.dc.totalPages;
              for(let j=0; j< res.data.patients.length;j++){
                var val1 = this.getAge(res.data.patients[j].dob);
                console.log(val1);
                this.allFilterPatientsCheck[j].Year = val1.years;
                this.allFilterPatientsCheck[j].Month = val1.months;
                this.allFilterPatientsCheck[j].Days = val1.days;
              }
              for(let i=0;i < res.data.patients.length; i++){
                date = new Date(res.data.patients[i].checkedoutLocalDate);
                var dstr = date.toLocaleDateString();
                var tstr = date.toLocaleTimeString();
                this.allFilterPatientsCheck[i].checkedoutLocalDate = dstr;
                this.allFilterPatientsCheck[i].checkedoutLocalTime = tstr;
              }
              
              for(let i = 0; i < res.data.patients.length; i++) {
              if(this.allFilterPatientsCheck[i].ptid !== null){
               this.allFilterPatientsCheck[i].ptid = res.data.patients[i].ptid.replace(/ /g,'');
               }
              }      
              //this.timeCheck = this.dateToLocalString(res.data.patients.checkoutLocalDate);
            }
            this.GetStagesList();
          } else if (what == 8000)
          {
            loader.hide();
            for(let k=0;k<res.data.list.length;k++){
            //dos
            res.data.list[k].dos = res.data.list[k].dos.split("T");
            res.data.list[k].dos = res.data.list[k].dos[0];
            //dare req
            res.data.list[k].billDate = res.data.list[k].billDate.split("T");
            res.data.list[k].billDate = res.data.list[k].billDate[0];
          }  
          this.filteredPaymentRequests = res.data.list;
          this.totalRowsPays = res.data.dc.totalRow;
          this.totalPagesPays = res.data.dc.totalPages;
         }else if (what == 900) {
            loader.hide();
            this.successToastUpd();
            this.filteredPaymentRequests = res.data.list;
          } else if (what == 9000) {
            $("#reminder").modal("hide");
            this.successToastUpd("Reminder sent successfully.");
          } else if (what == 9001) {
            this.filteredPaymentRequests = res.data.list;
            this.successToastUpd("Deleted successfully.");
          } else if (what == 9002){
             loader.hide();
             this.successToastUpd("Receipt sent successfully.");
             $("#displayReceipt").modal("hide");
          } else if (what == 9003){
             loader.hide();
             this.successToastUpd("Amount Refunded Successful!");
             for(let k=0;k<res.data.list.length;k++){
            //dos
            res.data.list[k].dos = res.data.list[k].dos.split("T");
            res.data.list[k].dos = res.data.list[k].dos[0];
            //dare req
            res.data.list[k].billDate = res.data.list[k].billDate.split("T");
            res.data.list[k].billDate = res.data.list[k].billDate[0];
          }  
          this.refundAmount = "";
          //this.filteredPaymentRequests = res.data.list;
          this.totalRowsPays = res.data.dc.totalRow;
          this.totalPagesPays = res.data.dc.totalPages;
          $("#displayReceipt11").modal("hide");
          this.getPaymentResTabl();
        } else if(what === 991){
               if (res.data.dc.auditFlag === 1) {
              this.checkoutPatients = res.data.patients;
              this.allFilterPatientsCheck = res.data.patients;
              this.totalRows = res.data.dc.totalRow;
              this.totalPages = res.data.dc.totalPages;
              for(let j=0; j< res.data.patients.length;j++){
                var val = this.getAge(res.data.patients[j].dob);
                this.allFilterPatientsCheck[j].Year = val.years;
                this.allFilterPatientsCheck[j].Month = val.months;
                this.allFilterPatientsCheck[j].Days = val.days;
              }
              for(let i=0;i < res.data.patients.length; i++){
                date = new Date(res.data.patients[i].checkedoutLocalDate);
                var dstrr = date.toLocaleDateString();
                var tstrr = date.toLocaleTimeString();
                this.allFilterPatientsCheck[i].checkedoutLocalDate = dstrr;
                this.allFilterPatientsCheck[i].checkedoutLocalTime = tstrr;
              }
              
              for(let i = 0; i < res.data.patients.length; i++) {
              if(this.allFilterPatientsCheck[i].ptid !== null){
               this.allFilterPatientsCheck[i].ptid = res.data.patients[i].ptid.replace(/ /g,'');
               }
              }      
              //this.timeCheck = this.dateToLocalString(res.data.patients.checkoutLocalDate);
            }
            this.GetStagesList();
          }
           else if (what === 14) {
            if (res.data.dc.auditFlag === 1) {
              this.insurance = res.data.insurances;
              if (this.insurance == null) {
                this.aSinglePatient.insurance = {
                  primaryInsurance: "",
                  primaryInsuranceId: "",
                  primaryInsuranceNo: "",
                  primaryInsuranceGroupId: "",
                  secondaryInsurance: "",
                  secondaryInsuranceId: "",
                  secondaryInsuranceNo: "",
                  secondaryInsuranceGroupId: "",
                };
              } else {
                this.aSinglePatient.insurance = res.data.insurances;
              }

              //visitDemo Date
              this.visitDemo = res.data.quests.quests;
              for(let k=0;k < this.visitDemo.length;k++){
               if(this.visitDemo[k].questTypeName == "Date"){
                 if(this.visitDemo[k].answer !== "" || this.visitDemo[k].answer == "Invalid date"){
                 this.visitDemo[k].answer = moment(String(this.visitDemo[k].answer)).format("YYYY-MM-DD");
               }
              }
            }
              
              this.visitQuests = res.data.quests.quests;
              this.requestPaymentsList = res.data.lpr;
              this.VhpageNumber =  res.data.dc.pageNumber;
              this.VhpageSize = res.data.dc.pageSize;
              this.VhtotalPages = res.data.dc.totalPages;
              this.VhtotalRows =  res.data.dc.totalRow;
              //PaymentHistory
             //debugger
              this.PhpageNumber =  res.data.dc.pageNumberP;
              this.PhpageSize = res.data.dc.pageSizeP;
              this.PhtotalPages = res.data.dc.totalPagesP;
              this.PhtotalRows =  res.data.dc.totalRowP;
              this.paymentHistory = res.data.paymentHistory;
             //PaymentHistory
              this.userTexts = res.data.userTexts;
              this.filterTextSearch = this.userTexts;
              this.emailHistory = res.data.emailHistory;
              this.VhpageNumber =  res.data.dc.pageNumber;
              this.VhpageSize = res.data.dc.pageSize;
              this.VhtotalPages = res.data.dc.totalPages;
              this.VhtotalRows =  res.data.dc.totalRow;
              this.visitHistory = res.data.visitHistory;
              var date = moment(String(this.aSinglePatient.dob)).format(
                "YYYY-MM-DD"
              );

              this.aSinglePatient.dob = date;
              this.aSinglePatient.externalId = res.data.patient.externalId;
              if (res.data.insurances != null) {
                this.insurance = res.data.insurances;
                if (this.insurance.secondaryInsuranceId == "")
                  this.insurance.secondaryInsuranceId = "Secondary Id";
                if (this.insurance.primaryInsuranceId == "")
                  this.insurance.primaryInsuranceId = "Insurance Id";
                //console.log((this.insurance = res.data.insurances));
              }
              this.users = res.data.users;
              console.log(this.aSinglePatient.insurance);
              $("#newptModal").modal("show");
            } else {
              this.errorToast(res.data.dc.auditFlagVal);
            }
            } else if (what === 5) {
              debugger;
                $("#mergeModal").modal("hide");
                $("#alertModal").modal("hide");
              if (res.data.dc.auditFlag > 0) {
                //this.allInsurances = res.data.insurance;
                //this.$router.go(0);
              
                this.successToastUpd();
              } else this.errorToast(res.data.dc.auditFlagVal);
          } else if (what == 7) {
            if (res.data.auditFlag == 1) {
              this.successToastUpd();
            } else {
              this.errorToastUpd(res.data.auditFlagVal);
            }
          } else if (what === 28) {
           //debugger // eslint-disable-line no-debugger
            this.requestPaymentClick_1();
            if (res.data.dc.auditFlag > 0) {
              // this.patients = res.data.main.patients;
              // this.stageSteps = res.data.main.stageSteps.stages;
              // this.insurance = res.data.main.insurance;
              this.successToastUpd();
              $("#debit1").modal("hide");
              $("#cash1").modal("hide");
              $("#cheque1").modal("hide");
            } else {
              this.errorToastUpd(res.data.dc.auditFlagVal);
            }
          } else if (what === 17) {
              this.successToastUpd();
          } else if (what === 15) {
            this.emailTempsList = res.data;
            this.emailTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
          } else if (what === 16) {
            this.successToastUpd();
              this.checkoutPatients = res.data.patients;
              this.allFilterPatientsCheck = res.data.patients;
              this.totalRows = res.data.dc.totalRow;
              this.totalPages = res.data.dc.totalPages;
              for(let j=0; j< res.data.patients.length;j++){
                var valOrder = this.getAge(res.data.patients[j].dob);
                this.allFilterPatientsCheck[j].Year = valOrder.years;
                this.allFilterPatientsCheck[j].Month = valOrder.months;
                this.allFilterPatientsCheck[j].Days = valOrder.days;
              }
              for(let i=0;i < res.data.patients.length; i++){
                date = new Date(res.data.patients[i].checkedoutLocalDate);
                var dstrOrder = date.toLocaleDateString();
                var tstrOrder = date.toLocaleTimeString();
                this.allFilterPatientsCheck[i].checkedoutLocalDate = dstrOrder;
                this.allFilterPatientsCheck[i].checkedoutLocalTime = tstrOrder;
              }
              
              for(let i = 0; i < res.data.patients.length; i++) {
              if(this.allFilterPatientsCheck[i].ptid !== null){
               this.allFilterPatientsCheck[i].ptid = res.data.patients[i].ptid.replace(/ /g,'');
               }
              } 
          } else if (what === 99) {
            if (res.data.auditFlag === 1) {
              this.successToastUpd();
              this.loadInit();
              $("#assignPhysician").modal("hide");
            }
          } else if (what === 18) {
            if (res.data.dc.auditFlag > 0) {
              if (res.data.lpr.length < -991) {
                this.ShowErrorAutoClose("No Payment Request was made.");
                return;
              }
              this.requestPaymentsList = res.data.lpr;
              let xx = this.requestPaymentsList.find(
                (f) => f.visitId == this.aSinglePatient.visitId
              );
              console.log(xx);
              if (typeof xx !== "undefined")
                this.aSingleRequestPayment = JSON.parse(JSON.stringify(xx));
              else {
                this.aSingleRequestPayment = {
                  billNo: 0,
                  amount: 0,
                  email: "",
                  phone: "",
                  comment: "",
                };

                this.getPaymentEmailPhone(this.PvisitId);
              }
              $("#paymentRequest").modal("show");
            }
          } else if (what === 188) {
           //debugger // eslint-disable-line no-debugger
            if (res.data.dc.auditFlag > 0) {
              if (res.data.lpr.length < -991) {
                this.ShowErrorAutoClose("No Payment Request was made.");
                return;
              }
              this.requestPaymentsList = res.data.lpr;
              let xx = this.requestPaymentsList.find(
                (f) => f.visitId == this.aSinglePatient.visitId
              );
              if (typeof xx !== "undefined")
                this.aSingleRequestPayment = JSON.parse(JSON.stringify(xx));
              else {
                this.aSingleRequestPayment = {
                  billNo: 0,
                  amount: 0,
                  email: "",
                  phone: "",
                  comment: "",
                };
              }
            }
          }  else if (what === 189) {
               this.aSingleRequestPayment.email= res.data.email;
               this.aSingleRequestPayment.phone= res.data.phone;  
          } else if (what === 19) {
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Reminder Sent");
            } else {
              this.errorToastUpd(res.data.auditFlagVal);
            }
          } else if (what === 20) {
           //debugger // eslint-disable-line no-debugger
            if (res.data.auditFlag > 0) {
              this.showProfilePopup(this.aSinglePatient, "");
              this.successToastUpd("Email Sent");
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 28) {
           //debugger // eslint-disable-line no-debugger
            this.smsTempsList = res.data;
            this.smsTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
            $("#sendText1").modal("show");
          } else if (what === 26) {
           //debugger // eslint-disable-line no-debugger
            if (res.data.auditFlag > 0) {
              this.showProfilePopup(this.aSinglePatient, "");
              this.chatSms = "";
              this.successToastUpd("Text message sent");
              $("#sendText1").modal("hide");
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 27) {
           //debugger // eslint-disable-line no-debugger
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Text message sent");
              this.getPatientInfo(this.aSinglePatient);
              this.chatSms = "";
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 24) {
           //debugger // eslint-disable-line no-debugger
            if (res.data.length > 0) {
              this.textHistory = res.data;
            } else {
              this.ShowErrorAutoClose("No data Exists");
            }
          } else if (what === 25) {
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Text message sent");
              $("#sendText1").modal("hide");
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 12) {
           //debugger
          loader.hide(); 
          this.successToastUpd();
          this.aSinglePaymentReceived.tdNumber = "";
          this.aSinglePaymentReceived.holderName = "";
          this.aSinglePaymentReceived.cardCVC = "";
          this.aSinglePaymentReceived.ExpirationDate = "";
          this.aSinglePaymentReceived.comment = "";
          this.aSinglePaymentReceived.zip = "";
          this.aSinglePaymentReceived.amount="";
            for(let k=0;k<res.data.list.length;k++){
            //dos
            res.data.list[k].dos = res.data.list[k].dos.split("T");
            res.data.list[k].dos = res.data.list[k].dos[0];
            //dare req
            res.data.list[k].billDate = res.data.list[k].billDate.split("T");
            res.data.list[k].billDate = res.data.list[k].billDate[0];
          }  
          this.filteredPaymentRequests = res.data.list;
          this.totalRowsPays = res.data.dc.totalRow;
          this.totalPagesPays = res.data.dc.totalPages;
          this.btnProColl = false;
          $("#cash").modal("hide");
          $("#debit").modal("hide");
          $("#cheque").modal("hide");
       }  else if (what === 21) {
            this.auditData = res.data.visitHist;
          } else if (what === 23) {
            if (res.data.dc.auditFlag > 0) {
              this.successToastUpd();
              this.allRawPatients = res.data.patients;
              this.stagesSteps = res.data.stageSteps;
              //this.allInsurances = res.data.insurance;
              this.stepRes = res.data.stepRes;
              $("#mergeModal").modal("hide");
              $("#alertModal").modal("hide");
            } else this.errorToast(res.data.dc.auditFlagVal);
          } else if (what === 24) {
           //debugger // eslint-disable-line no-debugger
            if (res.data.dc.auditFlag > 0) {
              this.successToastUpd();
              this.loadInit();
            } else this.errorToast(res.data.dc.auditFlagVal);
          } else if (what === 29) {
            this.stagesSteps = res.data.stages;
          } else if (what === 30) {
            if (res.data.dc.auditFlag === 1) {
              console.log("QUESTS: ", res.data);
              this.visitQuests = res.data.quests;
              $("#questionModal").modal("show");
            } else {
              this.ShowError(res.data.dc.auditFlagVal);
            }
          } else if (what === 31) {
            if (res.data.auditFlag === 1) {
              $("#questionModal").modal("hide");
              this.successToastUpd();
            }
          } else if (what === 32) {
           //debugger
           $("#v-" + Data.dc.visitId + "").prop("disabled", false);
             this.loadInit();
            // if (res.data.auditFlag === 1) {
            //this.$router.go(0);
            // }
          } else if (what === 33) {
            this.commentsList = res.data;
            $("#CommentModal").modal("show");
            $("#comment-text").focus();
          } else if (what === 34) {
            this.commentsList = res.data;
            this.commentText = "";
            this.successToastUpd();
          } else if (what === 35) {
            if (res.data.dc.auditFlag === 1) {
              this.visitTypes = res.data.types;
              this.visitReasons = res.data.reasons;
              this.getActiveVisitReasons(this.aSinglePatient.visitTypeId);
              $("#editVisit").modal("show");
            } else {
              this.errorToast("No Visit Type(s) found ...");
            }
          } else if (what === 36) {
            $("#editVisit").modal("hide");
            if (res.data.dc.auditFlag === 1) {
              //this.myData = res.data;
              //this.stepRes = res.data.stepRes;
              this.successToastUpd();
            } else {
              this.errorToast(res.data.dc.auditFlagVal);
            }
          } else if (what === 37) {
            if (res.data.dc.auditFlag > 0) {
              //this.requestPaymentsList = res.data.lpr;
              // this.patients = res.data.main.patients;
              // this.stageSteps = res.data.main.stageSteps.stages;
              // this.insurance = res.data.main.insurance;
              $("#paymentRequest").modal("hide");
              this.successToastUpd();
            } else {
              this.errorToastUpd(res.data.dc.auditFlagVal);
            }
          } else if (what === 38) {
            if (res.data.dc.auditFlag > 0) {
              this.requestPaymentsList = res.data.lpr;
            }
          } else if (what === 39) {
            this.smsTempsList = res.data;
            this.smsTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
            $("#sendText1").modal("show");
          } else if (what === 40) {
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Text message sent");
              this.chatSms = "";
              this.aSingleSms = {
                name: "",
                smsText: "",
              };
            } else {
              this.ShowErrorAutoClose("Unable to Send Text");
            }
          } else if (what === 41) {
            this.emailTempsList = res.data;
            this.emailTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
          } else if (what === 42) {
            if (res.data.auditFlag === 1) {
              this.successToastUpd();
              this.aSingleEmail = {
                name: "",
                emailSubject: "",
                emailText: "",
              };
            } else {
              this.errorToast(res.data.auditFlagVal);
            }
          } else if (what === 43) {
            if (res.data.dc.auditFlag === 1) {
              this.phyList = res.data.physicians;
              this.clearPhysicianAssignment();
              $("#assignPhysician").modal("show");
            } else {
              this.errorToast(res.data.dc.auditFlagVal);
            }
          } else if (what === 44) {
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;

            for (let i = 0; i < this.allPatients.length; i++) {
              const dd = new Date(this.allPatients[i].dob);
              this.allPatients[i].dob = dd.toLocaleDateString();
              //this.allPatients[i].dobd = dd;
            }

            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients.filter(
              (f) =>
                f.firstName == obj.firstName ||
                f.lastName == obj.lastName ||
                f.ssn == obj.ssn ||
                f.phone == obj.phone ||
                f.email == obj.email
            );
              for (var i = 0; i < this.suggestedPatients.length; i++) {
              if(this.suggestedPatients[i].ptid !== null){
              this.suggestedPatients[i].ptid = this.suggestedPatients[i].ptid.replace(/ /g,'');
            }
          }
            $("#mergeModal").modal("show");
          } else if (what === 45) {
            if (res.data.dc.auditFlag > 0) {
              this.successToastUpd();
              this.allRawPatients = res.data.patients;
              this.stagesSteps = res.data.stageSteps;
              //this.allInsurances = res.data.insurance;
              this.stepRes = res.data.stepRes;
              $("#mergeModal").modal("hide");
              $("#alertModal").modal("hide");
            } else this.errorToast(res.data.dc.auditFlagVal);
          } else if (what === 46) {
            if (res.data.auditFlag > 0){
               this.successToastUpd();
               this.loadInit();
            }
            else
            { 
              this.ShowErrorAutoClose("No data Exists");
            }
          } else if (what === 47) {
              this.insurance = res.data;
          }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            // alert("No response " + error.request);
          } else {
            // alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },

    clearSearchFields() {
      this.mainSearch.searchVeinsId = "";
      this.mainSearch.searchExternalId = "";
      this.mainSearch.searchFirstName = "";
      this.mainSearch.searchLastName = "";
      this.mainSearch.searchPhone = "";
    },

    datePicker() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDate11 = new Date(start);
          self.endDate11 = new Date(end);
          self.initDate_11 =
            self.dateToMDY(self.startDate11) +
            " - " +
            self.dateToMDY(self.endDate11);
        }
      );
    },

    datePicker_11() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDate = new Date(start);
          self.endDate = new Date(end);
          self.initDate =
            self.dateToMDY(self.startDate) +
            " - " +
            self.dateToMDY(self.endDate);
        }
      );
    },

    datePicker_1() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDate_1 = new Date(start);
          self.endDate_1 = new Date(end);
          self.initDate_1 =
            self.dateToMDY(self.startDate_1) +
            " - " +
            self.dateToMDY(self.endDate_1);
        }
      );
    },

    //payment request list filter
    searchMainList_1() {
      if (this.startDate != "" && this.endDate != "") {
        this.allFilterPatients_1 = this.requestPaymentsList.filter(
          (f) =>
            +new Date(f.dos) >= +new Date(this.startDate) &&
            +new Date(f.dos) <= +new Date(this.endDate)
        );
      }
    },

    //visit request list filter
    searchMainList_2() {
      if (this.startDate_1 != "" && this.endDate_1 != "") {
        this.allFilterVisitHist = this.visitHistory.filter(
          (f) =>
            +new Date(f.dosLocalTime) >= +new Date(this.startDate_1) &&
            +new Date(f.dosLocalTime) <= +new Date(this.endDate_1)
        );
      }
    },

    //payment histroy filter
    // searchMainList_3() {
    //   if (this.startDate_2 != "" && this.endDate_2 != "") {
    //     this.allFilterPayHist = this.paymentHistory.filter(
    //       (f) =>
    //         +new Date(f.dos) >= +new Date(this.startDate_2) &&
    //         +new Date(f.dos) <= +new Date(this.endDate_2)
    //     );
    //   }
    // },

    //main checkout filter
    searchMainList_11() {
      if (this.startDate11 != "" && this.endDate11 != "") {
        this.allFilterPatientsCheck = this.checkoutPatients.filter(
          (f) =>
            +new Date(f.dos) >= +new Date(this.startDate11) &&
            +new Date(f.dos) <= +new Date(this.endDate11)
        );
      }
    },

    searchMainList() {
      if (this.mainSearch.searchVeinsId.length > 0) {
        this.allFilterPatientsCheck = this.checkoutPatients.filter((f) =>
          (f.patientId + " ").includes(this.mainSearch.searchVeinsId)
        );
      } else if (this.mainSearch.searchExternalId.length > 0) {
        this.allFilterPatientsCheck = this.checkoutPatients.filter((f) =>
          (f.externalId + " ").includes(this.mainSearch.searchExternalId)
        );
      } else {
        this.allFilterPatientsCheck = this.checkoutPatients.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(this.mainSearch.searchFirstName.toLowerCase().trim()) &&
            f.lastName
              .toLowerCase()
              .startsWith(this.mainSearch.searchLastName.toLowerCase().trim())
        );
      }
    },
  },
  mounted() {
   
    if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    this.handleRole();
    this.loadInit();
    this.interval = setInterval(this.loadWitoutLoader, 20000);
  },
  unmounted() {
        clearTimeout(this.interval);
        clearTimeout(this.TimerObject);
    },
  watch: {
     allFilterPatientsCheck: function () {
        for (let i = 0; i < this.allFilterPatientsCheck.length; i++) {
          // this.allRawPatients[i].resStr = "";
          if (this.allFilterPatientsCheck[i].collection.collectedById > 0) {
            const d0 = new Date(this.allFilterPatientsCheck[i].collection.paymentDate);
            this.allFilterPatientsCheck[i].collection.paymentDateStr =
              d0.toLocaleDateString() + " " + d0.toLocaleTimeString();
          } 
          else this.allFilterPatientsCheck[i].collection.paymentDateStr = "";
        }

      for (let i = 0; i < this.allFilterPatientsCheck.length; i++) {
          let str = "";
          for (let j = 0; j < this.allFilterPatientsCheck[i].actions.length; j++) {
            const dd = new Date(this.allFilterPatientsCheck[i].actions[j].actionDate);
            this.allFilterPatientsCheck[i].actions[j].actionDateStr =
              dd.toLocaleDateString();
            this.allFilterPatientsCheck[i].actions[j].actionTimeStr =
              dd.toLocaleTimeString();
            const XA00 =
              "<" + this.allFilterPatientsCheck[i].actions[j].actionType + ">";
            if (str.indexOf(XA00) < 0) str += XA00;
            const d001 = new Date(this.allFilterPatientsCheck[i].actions[j].actionDate);
            if (this.allFilterPatientsCheck[i].actions[j].actionType == "500") {
              this.allFilterPatientsCheck[i].smsSentTo =
                this.allFilterPatientsCheck[i].actions[j].sentTo;
              this.allFilterPatientsCheck[i].smsActionText =
                this.allFilterPatientsCheck[i].actions[j].actionText;
              this.allFilterPatientsCheck[i].smsActionDateStr =
                d001.toLocaleDateString();
              this.allFilterPatientsCheck[i].smsActionTimeStr =
                d001.toLocaleTimeString();
            } else if (this.allFilterPatientsCheck[i].actions[j].actionType == "51") {
              this.allFilterPatientsCheck[i].emailSentTo =
                this.allFilterPatientsCheck[i].actions[j].sentTo;
              this.allFilterPatientsCheck[i].emailActionText =
                this.allFilterPatientsCheck[i].actions[j].actionText;
              this.allFilterPatientsCheck[i].emailActionDateStr =
                d001.toLocaleDateString();
              this.allFilterPatientsCheck[i].emailActionTimeStr =
                d001.toLocaleTimeString();
              this.allFilterPatientsCheck[i].emailSubject =
                this.allFilterPatientsCheck[i].actions[j].subject;
            } else if (this.allFilterPatientsCheck[i].actions[j].actionType == "301") {
              this.allFilterPatientsCheck[i].paymentRequestActionDateStr =
                d001.toLocaleDateString();
              this.allFilterPatientsCheck[i].paymentRequestActionTimeStr =
                d001.toLocaleTimeString();
            } else if (this.allFilterPatientsCheck[i].actions[j].actionType == "100") {
              this.allFilterPatientsCheck[i].commentActionDateStr =
                d001.toLocaleDateString();
              this.allFilterPatientsCheck[i].commentActionTimeStr =
                d001.toLocaleTimeString();
            } else if (this.allFilterPatientsCheck[i].actions[j].actionType == "50") {
              this.allFilterPatientsCheck[i].editActionDateStr =
                d001.toLocaleDateString();
              this.allFilterPatientsCheck[i].editActionTimeStr =
                d001.toLocaleTimeString();
            }
          }
          this.allFilterPatientsCheck[i].actionString = str;
        }
      },
    initDate_2: function() {
      this.fetchVisitistory();
    },
    checkoutPatients: function () {
      //   //alert(this.ques.length);
      this.searchMainList();
      this.$nextTick(() => {
        $("#checkoutPatients").DataTable().destroy();
        $("#checkoutPatients").DataTable({
            pageLength: 50,
            lengthMenu: [
              [50, 100, 500, 1000, 2000],
              [50, 100, 500, 1000, 2000],
            ],
        });
        $(
          ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
        ).addClass("btn btn-primary mr-1");
        $(".checkoutPatients").DataTable().draw();
      }); // this.$nextTick
    },

    //For search
    requestPaymentsList: function () {
      try {
        for (let i = 0; i < this.requestPaymentsList.length; i++) {
          let dd = new Date(this.requestPaymentsList[i].dos);
          this.requestPaymentsList[i].dosDate = dd.toLocaleDateString();
          dd = new Date(this.requestPaymentsList[i].billDate);
          this.requestPaymentsList[i].billDateDate = dd.toLocaleDateString();

          this.requestPaymentsList[i].inputStatus =
            this.requestPaymentsList[i].status;
        }
      } catch {
        /**/
      } finally {
        this.allFilterPatients_1 = this.requestPaymentsList;
        this.searchMainList_1();
      }
    },

    phyList: function () {
      this.clearPhysicianAssignment();
      for (let i = 0; i < this.phyList.length; i++)
        if (this.phyList[i].physicianId == this.aSinglePatient.physicianId)
          this.phyList[i].isAlloted = 1;
    },

    commentsList: function (val) {
      for (let i = 0; i < val.length; i++) {
        const dd = new Date(val[i].commentLocalDate);
        val[i].commentLocalDate =
          dd.toLocaleDateString() + " " + dd.toLocaleTimeString();
      }
    },

    //For search
    visitHistory: function () {
        // this.$nextTick(() => {
        //   $("#visitm")
        //     .DataTable()
        //     .destroy();
        //   $("#visitm").DataTable({
        //     pageLength: 50,
        //     lengthMenu: [
        //       [50, 100, 500, 1000, 2000, -1],
        //       [50, 100, 500, 1000, 2000],
        //     ],
        //   });
        //   $(
        //     ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
        //   ).addClass("btn btn-primary mr-1");
        //   $("#visitm")
        //     .DataTable()
        //     .draw();
        // });
    },

    "aSinglePatient.visitTypeId": function () {
      this.getActiveVisitReasons(this.aSinglePatient.visitTypeId);
    },
    "mainSearch.searchVeinsId": function () {
      this.searchMainList();
    },
    "mainSearch.searchExternalId": function () {
      this.searchMainList();
    },
    "mainSearch.searchFirstName": function () {
      this.searchMainList();
    },
    "mainSearch.searchLastName": function () {
      this.searchMainList();
    },
    "mainSearch.searchPhone": function () {
      this.searchMainList();
    },
    startDate11: function () {
      this.searchMainList_11();
    },
    endDate11: function () {
      this.searchMainList_11();
    },
    startDate: function () {
      this.searchMainList_1();
    },
    endDate: function () {
      this.searchMainList_1();
    },
    startDate_1: function () {
      this.searchMainList_2();
    },
    endDate_1: function () {
      this.searchMainList_2();
    },
    // startDate_2: function () {
    //   this.searchMainList_3();
    // },
    // endDate_2: function () {
    //   this.searchMainList_3();
    // },
    filterFirstName: function () {
      this.filterSearchList();
    },

    filterLastName: function () {
      this.filterSearchList();
    },

    filterPhone: function () {
      this.filterSearchList();
    },

    filterDate: function () {
      // let dd = new Date(this.filterDate);
      // let ds = dd.toLocaleDateString();
      //   alert(dd);
      this.filterSearchList();
    },
  },
};

